module.exports = __webpack_public_path__ + "static/img/8.2aece31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/8.jpg
// module id = 3uVI
// module chunks = 1